export default "__VITE_ASSET__CQb1onkR__"